import { writable } from "svelte/store";

const initialState = {
  sections: [],
  perSection: 1,
};

const storeKey = "elt1/userApp/settings";

const createStore = () => {
  const persistGet = () => {
    const v = localStorage.getItem(storeKey);
    return v ? JSON.parse(v) : initialState;
  };
  const persistSet = (state) => {
    localStorage.setItem(storeKey, JSON.stringify(state));
  };

  const { set, subscribe, update } = writable(persistGet() ?? initialState);
  return {
    set: (state) => {
      persistSet(state);
      set(state);
    },
    subscribe,
    update: (updater) => {
      update((state) => {
        const newState = updater(state);
        persistSet(newState);
        return newState;
      });
    },
  };
};

export const SettingsState = createStore();
